import TokenService from '@/helpers/token'
import Repository from './Repository'

const baseUrl = Repository.defaults.baseURL
const list = `${baseUrl}/notification`

export default {
  async list (params) {
    const response = await Repository.get(`${list}`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async update(id, params) {
    const response = await Repository.put(`${list}/${id}`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },
}
